(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-releases"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const section = document.querySelector('.artist-releases[data-tag-url]');
      if (!section) return;
      const grid = section.querySelector('[data-artist-releases-grid]');
      if (!grid) return;
      if (grid.querySelectorAll('.artist-releases__card').length > 0) return;

      const tagUrl = section.dataset.tagUrl;
      const artistName = (section.dataset.artistName || '').toLowerCase().trim();
      const artistHandle = (section.dataset.artistHandle || '').toLowerCase().trim();
      const limit = parseInt(section.dataset.limit || '8', 10);
      const isDesignMode = Boolean(section.dataset.designMode);

      if (!artistHandle) {
        if (!isDesignMode) {
          section.hidden = true;
          section.style.display = 'none';
        }
        return;
      }

      const collectedCards = new Map();

      const addCardFromElement = (card) => {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        const href = link.getAttribute('href') || '';
        const handle = href.split('/products/')[1]?.split('?')[0];
        if (handle && !collectedCards.has(handle)) {
          card.classList.add('artist-releases__card');
          collectedCards.set(handle, card);
        }
      };

      const renderCollected = () => {
        if (collectedCards.size > 0) {
          grid.innerHTML = '';
          Array.from(collectedCards.values()).slice(0, limit).forEach((card) => {
            grid.appendChild(card);
          });
        } else if (!isDesignMode) {
          section.hidden = true;
          section.style.display = 'none';
        } else {
          grid.innerHTML = '<p class="artist-releases__empty-note">No releases found for this artist.</p>';
        }
      };

      const isRedirectedAway = (res, handle) => {
        if (!res) return true;
        if (res.redirected) return true;
        try {
          const finalUrl = new URL(res.url, window.location.origin);
          const parts = finalUrl.pathname.toLowerCase().split('/').filter(Boolean);
          const last = decodeURIComponent(parts[parts.length - 1] || '');
          if (last !== handle.toLowerCase()) {
            return true;
          }
        } catch (e) {
          return true;
        }
        return false;
      };

      const fetchTagPromise = tagUrl
        ? fetch(tagUrl)
            .then((res) => {
              if (!res.ok || isRedirectedAway(res, artistHandle)) {
                return null;
              }
              return res.text();
            })
            .then((html) => {
              if (!html) return;
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              if (doc.querySelector('.collection-page__empty')) return;
              const cards = doc.querySelectorAll('.collection-products .collection-product, .collection-lockjaw__card');
              cards.forEach(addCardFromElement);
            })
            .catch(() => {})
        : Promise.resolve();

      let searchTagQuery = `tag:${artistHandle}`;
      if (artistName && artistName !== artistHandle) {
        searchTagQuery += ` OR tag:"${artistName}"`;
      }
      const searchTagUrl = `/search?type=product&q=${encodeURIComponent(searchTagQuery)}`;
      const fetchSearchPromise = fetch(searchTagUrl)
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => {
          if (!html) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const cards = doc.querySelectorAll('.search-results .search-result');
          cards.forEach(addCardFromElement);
        })
        .catch(() => {});

      Promise.all([fetchTagPromise, fetchSearchPromise]).then(() => {
        renderCollected();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initializeCartPage(root) {
    const form = root.querySelector('[data-cart-form]');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';

    form.querySelectorAll('[data-cart-stepper]').forEach((stepper) => {
      const input = stepper.querySelector('input[type="number"]');
      if (!input) return;

      stepper.querySelectorAll('[data-cart-quantity-change]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.cartQuantityChange, 10) || 0;
          const current = parseInt(input.value, 10) || 0;
          const next = Math.max(0, current + step);
          input.value = next;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      input.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  }

  initializeCartPage(document);
  document.addEventListener('shopify:section:load', (event) => initializeCartPage(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-lockjaw"]) return;
  try {
    
  // Sort dropdown handling
  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');
    if (sortByParam && select.value !== sortByParam) {
      select.value = sortByParam;
    }

    select.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Mobile drawer filter toggle
  const filterDrawer = document.querySelector('.collection-filters');
  const filterBackdrop = document.querySelector('.collection-filters-backdrop');
  const toggleBtn = document.querySelector('[data-toggle-filters]');
  const closeBtns = document.querySelectorAll('[data-close-filters]');

  const openDrawer = () => {
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterBackdrop) filterBackdrop.classList.add('is-active');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterBackdrop) filterBackdrop.classList.remove('is-active');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  if (toggleBtn) {
    toggleBtn.addEventListener('click', openDrawer);
  }

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Auto-submit filter form on desktop
  document.querySelectorAll('.collection-filters__form').forEach((form) => {
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!window.matchMedia('(max-width: 1024px)').matches) {
          form.requestSubmit();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Sort dropdown handling
  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');
    if (sortByParam && select.value !== sortByParam) {
      select.value = sortByParam;
    }

    select.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Mobile drawer filter toggle
  const filterDrawer = document.querySelector('.collection-filters');
  const filterBackdrop = document.querySelector('.collection-filters-backdrop');
  const toggleBtn = document.querySelector('[data-toggle-filters]');
  const closeBtns = document.querySelectorAll('[data-close-filters]');

  const openDrawer = () => {
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterBackdrop) filterBackdrop.classList.add('is-active');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterBackdrop) filterBackdrop.classList.remove('is-active');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  if (toggleBtn) {
    toggleBtn.addEventListener('click', openDrawer);
  }

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Auto-submit filter form on desktop
  document.querySelectorAll('.collection-filters__form').forEach((form) => {
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!window.matchMedia('(max-width: 1024px)').matches) {
          form.requestSubmit();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseColor = (value) => {
      if (!value) return null;
      const color = value.trim();
      if (color.startsWith('#')) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          return hex.split('').map((c) => parseInt(c + c, 16));
        }
        if (hex.length === 6) {
          return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
        }
      }
      const rgb = color.match(/rgba?\(([^)]+)\)/i);
      if (rgb) {
        return rgb[1]
          .split(',')
          .slice(0, 3)
          .map((channel) => parseFloat(channel.trim()));
      }
      return null;
    };

    const luminance = ([r, g, b]) => {
      const toLinear = (channel) => {
        const s = channel / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
      };
      return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
    };

    document.querySelectorAll('.custom-section[data-auto-contrast]').forEach((section) => {
      const cssValue = getComputedStyle(section).getPropertyValue('--custom-section-bg');
      const rgb = parseColor(cssValue);
      if (!rgb) return;
      section.classList.toggle('is-dark-bg', luminance(rgb) < 0.34);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Search bar toggle handling
    const searchBar = document.getElementById('site-header-search');
    const searchToggles = document.querySelectorAll('[data-search-toggle]');
    const searchCloses = document.querySelectorAll('[data-search-close]');
    const searchInput = searchBar ? searchBar.querySelector('.site-header__search-input') : null;

    if (searchBar && searchToggles.length) {
      let lastFocusedToggle = null;

      const openSearch = (trigger) => {
        lastFocusedToggle = trigger;
        searchBar.removeAttribute('hidden');
        searchBar.classList.add('is-open');
        searchBar.setAttribute('aria-hidden', 'false');
        searchToggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 60);
        }
      };

      const closeSearch = () => {
        searchBar.setAttribute('hidden', '');
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
        searchToggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        if (lastFocusedToggle) {
          lastFocusedToggle.focus();
        }
      };

      searchToggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = searchBar.classList.contains('is-open');
          if (isOpen) {
            closeSearch();
          } else {
            openSearch(btn);
          }
        });
      });

      searchCloses.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          closeSearch();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
          e.preventDefault();
          closeSearch();
        }
      });
    }

    // Mobile menu handling
    document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
      const toggle = menu.querySelector('.site-header__mobile-toggle');
      menu.addEventListener('toggle', () => {
        toggle.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.removeAttribute('open');
        });
      });

      menu.querySelectorAll('.site-header__mobile-group summary').forEach((summary) => {
        summary.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

      menu.querySelectorAll('.site-header__mobile-group').forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          menu.querySelectorAll('.site-header__mobile-group').forEach((other) => {
            if (other !== group) other.removeAttribute('open');
          });
        });
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          menu.removeAttribute('open');
          menu.querySelector('.site-header__mobile-toggle').focus();
        }
        if (event.key === 'Tab' && menu.open) {
          const targets = Array.from(menu.querySelectorAll('summary, a[href], button, input')).filter((node) => node.getClientRects().length);
          const first = targets[0];
          const last = targets[targets.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const initialize = (carousel) => {
      if (instances.has(carousel)) return;
      const slides = Array.from(carousel.querySelectorAll('[data-home-hero-slide]'));
      if (slides.length < 2) return;
      const controller = new AbortController();
      const { signal } = controller;
      const dots = Array.from(carousel.querySelectorAll('[data-home-hero-dot]'));
      const pauseButton = carousel.querySelector('[data-home-hero-pause]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = carousel.dataset.autoplay === 'true';
      const interval = Math.max(1000, Number(carousel.dataset.interval) || 5000);
      let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let paused = false;
      let hovered = false;
      let editorSelected = false;
      let timer;
      const setActive = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          slide.setAttribute('aria-hidden', String(i !== active));
          slide.inert = i !== active;
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-current', String(i === active));
        });
      };
      const stop = () => { window.clearInterval(timer); timer = undefined; };
      const update = () => {
        stop();
        if (pauseButton) {
          pauseButton.hidden = motion.matches;
          const label = paused ? 'Resume slideshow' : 'Pause slideshow';
          pauseButton.setAttribute('aria-label', label);
          pauseButton.setAttribute('title', label);
          pauseButton.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
          pauseButton.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        }
        if (!autoplay || motion.matches || paused || hovered || editorSelected || document.hidden || carousel.contains(document.activeElement)) return;
        timer = window.setInterval(() => setActive(active + 1), interval);
      };
      const on = (target, event, handler) => target?.addEventListener(event, handler, { signal });
      on(carousel.querySelector('[data-home-hero-prev]'), 'click', () => setActive(active - 1));
      on(carousel.querySelector('[data-home-hero-next]'), 'click', () => setActive(active + 1));
      dots.forEach((dot) => on(dot, 'click', () => setActive(Number(dot.dataset.homeHeroDot))));
      on(pauseButton, 'click', () => { paused = !paused; update(); });
      on(carousel, 'mouseenter', () => { hovered = true; update(); });
      on(carousel, 'mouseleave', () => { hovered = false; update(); });
      on(carousel, 'focusin', stop);
      on(carousel, 'focusout', () => queueMicrotask(() => { if (!signal.aborted) update(); }));
      on(document, 'visibilitychange', update);
      on(motion, 'change', update);
      on(carousel, 'shopify:block:select', (event) => {
        const index = slides.indexOf(event.target.closest('[data-home-hero-slide]'));
        if (index < 0) return;
        editorSelected = true;
        setActive(index);
        update();
      });
      on(carousel, 'shopify:block:deselect', () => { editorSelected = false; update(); });
      instances.set(carousel, () => { stop(); controller.abort(); instances.delete(carousel); });
      setActive(active);
      update();
    };
    const find = (root) => root.querySelectorAll('[data-home-hero]');
    find(document).forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => find(event.target).forEach(initialize));
    document.addEventListener('shopify:section:unload', (event) => find(event.target).forEach((carousel) => instances.get(carousel)?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lj-playlist')) {
    customElements.define('lj-playlist', class extends HTMLElement {
      connectedCallback() {
        const template = this.querySelector('template');
        if (!template || this.dataset.ready) return;
        this.dataset.ready = 'true';

        const play = () => {
          const player = template.content.cloneNode(true);
          this.replaceChildren(player);
          const iframe = this.querySelector('iframe');
          if (iframe) iframe.focus();
        };

        this.addEventListener('click', play, { once: true });
        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'button');
        this.setAttribute('aria-label', 'Play playlist');
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            play();
          }
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initializeProductForms(root) {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      const selector = section.querySelector('[data-product-variant]');
      if (!selector || selector.dataset.initialized) return;
      selector.dataset.initialized = 'true';

      const isPreorder = section.dataset.isPreorder === 'true';

      const optionsContainer = section.querySelector('[data-product-options]');
      const nativeVariantWrap = section.querySelector('[data-native-variant]');

      if (optionsContainer) {
        if (nativeVariantWrap) nativeVariantWrap.hidden = true;
        optionsContainer.hidden = false;

        const variantOptions = Array.from(selector.options);
        const optionGroups = Array.from(optionsContainer.querySelectorAll('.product-option-group'));

        const getSelectedValues = () => {
          return optionGroups.map((group) => {
            const radio = group.querySelector('[data-option-radio]:checked');
            if (radio) return radio.value;
            const select = group.querySelector('[data-option-select]');
            if (select) return select.value;
            return '';
          });
        };

        const updateAvailabilityStates = (selectedVals) => {
          optionGroups.forEach((group, groupIdx) => {
            const chips = group.querySelectorAll('.product-option-chip');
            chips.forEach((chip) => {
              const input = chip.querySelector('[data-option-radio]');
              if (!input) return;
              const testCombo = [...selectedVals];
              testCombo[groupIdx] = input.value;

              const matched = variantOptions.find((opt) => {
                const opt1 = opt.dataset.option1 || '';
                const opt2 = opt.dataset.option2 || '';
                const opt3 = opt.dataset.option3 || '';
                if (testCombo[0] && opt1 !== testCombo[0]) return false;
                if (testCombo[1] && opt2 !== testCombo[1]) return false;
                if (testCombo[2] && opt3 !== testCombo[2]) return false;
                return true;
              });

              chip.classList.toggle('product-option-chip--unavailable', !matched);
              chip.classList.toggle(
                'product-option-chip--sold-out',
                Boolean(matched && matched.dataset.available !== 'true')
              );
            });
          });
        };

        const onOptionChange = () => {
          const selectedVals = getSelectedValues();

          // Update header label displays
          optionGroups.forEach((group, idx) => {
            const display = group.querySelector('[data-option-selected-display]');
            if (display && selectedVals[idx]) {
              display.textContent = selectedVals[idx];
            }
          });

          // Match variant across all selected options
          const matched = variantOptions.find((opt) => {
            const opt1 = opt.dataset.option1 || '';
            const opt2 = opt.dataset.option2 || '';
            const opt3 = opt.dataset.option3 || '';
            if (selectedVals[0] && opt1 !== selectedVals[0]) return false;
            if (selectedVals[1] && opt2 !== selectedVals[1]) return false;
            if (selectedVals[2] && opt3 !== selectedVals[2]) return false;
            return true;
          });

          if (matched) {
            selector.value = matched.value;
            selector.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const submit = section.querySelector('[data-product-submit]');
            if (submit) {
              submit.disabled = true;
              submit.textContent = 'Unavailable';
            }
            const availability = section.querySelector('[data-product-availability]');
            if (availability) {
              availability.textContent = 'Unavailable';
              availability.classList.add('product-availability--sold-out');
            }
          }

          updateAvailabilityStates(selectedVals);
        };

        optionsContainer.addEventListener('change', onOptionChange);
        updateAvailabilityStates(getSelectedValues());
      }

      const updateVariant = () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';

        // Keep option controls in sync if selector value changed programmatically
        if (optionsContainer) {
          const optVals = [
            option.dataset.option1 || '',
            option.dataset.option2 || '',
            option.dataset.option3 || ''
          ];
          optionsContainer.querySelectorAll('.product-option-group').forEach((group, idx) => {
            const val = optVals[idx];
            if (!val) return;
            const radio = group.querySelector(`[data-option-radio][value="${CSS.escape(val)}"]`);
            if (radio && !radio.checked) radio.checked = true;
            const select = group.querySelector('[data-option-select]');
            if (select && select.value !== val) select.value = val;
            const display = group.querySelector('[data-option-selected-display]');
            if (display) display.textContent = val;
          });
        }

        const priceEl = section.querySelector('[data-product-price]');
        if (priceEl) priceEl.textContent = option.dataset.price;

        const availability = section.querySelector('[data-product-availability]');
        if (availability) {
          availability.textContent = available ? (isPreorder ? 'Pre-order' : 'In stock') : 'Sold out';
          availability.classList.toggle('product-availability--sold-out', !available);
          availability.classList.toggle('product-availability--preorder', available && isPreorder);
        }

        const submit = section.querySelector('[data-product-submit]');
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? (isPreorder ? 'Pre-order' : 'Add to cart') : 'Sold out';
        }

        const payment = section.querySelector('[data-product-payment]');
        if (payment) payment.hidden = !available;

        // Update URL query parameter without page reload
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({ path: url.href }, '', url.href);
        }
      };

      selector.addEventListener('change', updateVariant);
      updateVariant();

      // Quantity stepper
      section.querySelectorAll('[data-quantity-wrapper]').forEach((wrapper) => {
        if (wrapper.dataset.initialized) return;
        wrapper.dataset.initialized = 'true';
        const input = wrapper.querySelector('input[type="number"]');
        if (!input) return;
        wrapper.querySelectorAll('[data-quantity-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const step = parseInt(btn.dataset.quantityChange, 10) || 0;
            const current = parseInt(input.value, 10) || 1;
            const min = parseInt(input.min, 10) || 1;
            const max = input.max ? parseInt(input.max, 10) : Infinity;
            const next = Math.min(max, Math.max(min, current + step));
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      });
    });
  }
  initializeProductForms(document);
  document.addEventListener('shopify:section:load', (event) => initializeProductForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modal = document.querySelector('.welcome-modal');
    if (!modal) return;

    const storageKey = modal.dataset.storageKey || 'lockjaw_welcome_modal_v1';
    const isPreview = modal.dataset.preview === 'true';
    const delay = (parseFloat(modal.dataset.delay) || 1) * 1000;

    // Check localStorage
    if (!isPreview) {
      try {
        if (localStorage.getItem(storageKey) === 'true') {
          modal.remove();
          return;
        }
      } catch (e) {
        // localStorage unavailable
      }
    }

    const slider = modal.querySelector('[data-modal-slider]');
    const slides = Array.from(modal.querySelectorAll('.welcome-modal__slide'));
    const dots = Array.from(modal.querySelectorAll('.welcome-modal__dot'));
    const prevBtn = modal.querySelector('[data-modal-prev]');
    const nextBtn = modal.querySelector('[data-modal-next]');
    const dismissTriggers = modal.querySelectorAll('[data-modal-dismiss]');
    let currentIndex = 0;
    const totalSlides = slides.length;
    let lastActiveElement = null;

    const updateSlide = (newIndex) => {
      currentIndex = Math.max(0, Math.min(newIndex, totalSlides - 1));

      slides.forEach((slide, i) => {
        const active = i === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });

      dots.forEach((dot, i) => {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });

      // Prev button visibility & state
      if (prevBtn) {
        const hasPrev = currentIndex > 0;
        prevBtn.style.visibility = hasPrev ? 'visible' : 'hidden';
        prevBtn.disabled = !hasPrev;
        prevBtn.tabIndex = hasPrev ? 0 : -1;
      }

      // Next / Done button label
      if (nextBtn) {
        const isLast = currentIndex === totalSlides - 1;
        const nextLabel = nextBtn.dataset.labelNext || 'Next';
        const doneLabel = nextBtn.dataset.labelDone || 'Explore site';
        nextBtn.textContent = isLast ? doneLabel : nextLabel;
      }
    };

    const showModal = () => {
      lastActiveElement = document.activeElement;
      modal.style.display = 'flex';
      requestAnimationFrame(() => {
        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          if (nextBtn) nextBtn.focus();
        }, 100);
      });
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';

      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);

      if (!isPreview) {
        try {
          localStorage.setItem(storageKey, 'true');
        } catch (e) {}
      }

      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    };

    // Next / Prev listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (currentIndex < totalSlides - 1) {
          updateSlide(currentIndex + 1);
        } else {
          closeModal();
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          updateSlide(currentIndex - 1);
        }
      });
    }

    // Dot click listeners
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.dataset.gotoSlide, 10);
        if (!isNaN(target)) updateSlide(target);
      });
    });

    // Dismiss triggers (X, backdrop, links)
    dismissTriggers.forEach((trigger) => {
      trigger.addEventListener('click', closeModal);
    });

    // Keyboard support and focus trapping
    modal.addEventListener('keydown', (e) => {
      if (modal.hasAttribute('hidden')) return;

      if (e.key === 'Tab') {
        const focusable = Array.from(modal.querySelectorAll(
          'button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
        )).filter((el) => !el.closest('[inert]') && (el.offsetParent !== null || el.getClientRects().length > 0));

        if (focusable.length > 0) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });

    window.addEventListener('keydown', (e) => {
      if (modal.hasAttribute('hidden')) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      } else if (e.key === 'ArrowRight' && currentIndex < totalSlides - 1) {
        updateSlide(currentIndex + 1);
      } else if (e.key === 'ArrowLeft' && currentIndex > 0) {
        updateSlide(currentIndex - 1);
      }
    });

    // Open with delay
    setTimeout(showModal, isPreview ? 200 : delay);

    // Shopify theme editor integration
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const slideIndex = slides.findIndex((s) => s.contains(e.target));
        if (slideIndex !== -1) {
          showModal();
          updateSlide(slideIndex);
        }
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.contains(modal)) {
          showModal();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
